"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleError = handleError;
exports.handleJSON = handleJSON;
async function handleError(res) {
  if (res.ok) {
    return res;
  }
  const message = `Fetch: ${res.status} ${res.statusText}.`;
  const maybeData = await (async () => {
    try {
      return `Data: ${JSON.stringify(await res.json(), null, "  ")}`;
    } catch (e) {
      return "";
    }
  })();
  return Promise.reject(new Error(`${message} ${maybeData}`));
}
function isErrorResponse(data) {
  return data.error_code != undefined;
}
async function handleJSON(res) {
  const data = await handleError(res).then(r => r.json());

  // Our API convention
  if (isErrorResponse(data)) {
    return Promise.reject(new Error(data.message || `Unknown ApiError: ${data.message || ""}. Data: ${JSON.stringify(data, null, "  ")}`));
  }
  return data;
}